<script>
import appConfig from "@/app.config";
import QrcApi from "@/services/qrc-api";
import ClaimApi from "@/services/claim-api";


export default {

  props:{
    supplierId: Number,
    blnum:{
          type:String,
          default:""
      },
    ts:{
        type:String,
        default:""
    },
    codclt:{
        type:String,
        default:""
    },
  },

  page: {
    title: "Nouvelle Reclamation",
    meta: [{ name: "description", content: appConfig.description }]
  },

  data() {
    return {
        subject: null,
        message: null,   
        servicesList: [],
        selectedService:null,
        selectedType:null,
        createdClaimId: null,
        isAddClaimInProgress: false,

        
        // Boolean flags to show errors
        showSubjectError: false,
        showMessageError: false,
    };
  },

  computed:{
    isClaimTypeEnabled(){
      return  process.env.VUE_APP_FEATURE_CLAIM_TYPE === 'true'
    },
    customerAsstesDiractory(){
      return process.env.VUE_APP_CUSTOMER_ASSETS_DIRACTORY
    },
    customerAddress() {
      return process.env.VUE_APP_CUSTOMER_ADDRESS;
    },
    customerEmail() {
      return process.env.VUE_APP_CUSTOMER_EMAIL;
    },
    customerPhone() {
      return process.env.VUE_APP_CUSTOMER_PHONE;
    },
    customerUrl() {
      return process.env.VUE_APP_CUSTOMER_URL;
    },
  
  },
  mounted(){
    if(this.isClaimTypeEnabled){
      this.getClaimsServices();
    }
  },
  watch:{
    selectedService(newValue){
      this.selectedService= newValue
      this.selectedType = null
    }
    
    
  },
  methods: {
     
      getClaimsServices(){
        ClaimApi.getClaimsServices(null,null,null,false).then(
          response => {    
            this.servicesList = response.list; 
               
        })
      },

      addClaimWithQrc() {

        this.showSubjectError = false;
        this.showMessageError = false;
        let valid = true;

        if (!this.subject) {
          this.showSubjectError = true;
          valid = false;
        }

        if (!this.message) {
          this.showMessageError = true;
          valid = false;
        }

        if (!valid) {
          return;
        }

        this.isAddClaimInProgress=true;
        QrcApi.addClaimWithQrc(this.codclt, this.blnum, this.ts, this.subject, this.message,this.selectedService == null ? null : this.selectedService.id,this.selectedType == null ? null : this.selectedType.id)
        .then(createdClaimId => { 
            this.createdClaimId = createdClaimId; 
            this.isAddClaimInProgress=false;
            this.subject = null;
            this.message = null;
            this.selectedService = null;
            this.selectedType = null;
          })
          .finally(() => {
           
            this.isAddClaimInProgress=false;
          });   
             
      },
      


  },
    
  
};
</script>

<template class="bg-light">

  <div class="bg-light" >
    <vue-snotify></vue-snotify>

    <div class="row p-2" style="height: 100vh; width: 100vw;">
      <div class="card col-12" style="border:1px solid #ddd;">
          <div v-if="!createdClaimId" class="card-body m-2 p-0">
            
                <div class="row">

                  <div class="col-12 text-center">
                    <router-link to="/"  id="logo" >
                        <img :src="customerAsstesDiractory + 'logo.png'" alt width="150px"/>
                    </router-link>
                  </div>

                </div>


                <div class="row mt-4">

                  <div class="col-12">
                    <h1 class="text-left text-primary font-weight-bold text-center text-uppercase" style="font-size:1.4em;">Formulaire de réclamation </h1>
                    <!-- <h2 class="text-dark text-center font-weight-bold" style="font-size:1.4em;">{{ blnum || '_' }}</h2> -->
                  </div>
    
                </div>

                <div class="row mt-4">
                  <div class="col-sm-2 col-xs-0"/>

                    <div :class="isClaimTypeEnabled ? 'col-12  col-lg-5 pt-4 mr-4' : 'col-6 pt-4'">

                      <div class="text-dark mr-1" >BL numéro</div>
                      <span class="text-dark font-weight-bold" >{{ blnum || '_' }}</span>
                    </div>

                    <div class=" text-left" :class="isClaimTypeEnabled ? 'col-12 col-lg-4 ml-lg-5' : 'col-12 col-lg-4 '">
                      <div class="text-dark" >Code client</div>
                      <span class="text-dark font-weight-bold" >{{ codclt || '_' }}</span>
                    </div>

                    <!-- <div class="col-6">
                      <div class="text-dark" >BL numéro</div>
                      <span class="text-dark font-weight-bold" >{{ blnum || '_' }}</span>
                    </div> -->

                    <!-- <div class="col-12 mt-2">
                        <div class="text-secondary text-justify" >Merci de vérifier les informations ci-dessus avant de poursuivre votre réclamation.</div>
                    </div> -->
                </div>

                <div class="row pt-4 mt-2"> 
                     
                  <div class="col-lg-2  col-xs-0"/>

                    <div class="font-size-14 " 
                    :class="isClaimTypeEnabled ? 'col-12  col-lg-5 pt-4 mr-4' : 'col-12  col-lg-8 pt-4 mr-4'">
                      <div >
                          <b-form-group label-for="">
                            <label class="text-dark">
                              <span style="color : black">Objet</span><span class="text-danger"> *</span>
                            </label>
                            <b-form-input v-model="subject" :maxlength="50" class="form-control font-size-14 font-weight-bold text-dark" placeholder="Objet"/>
                            <div v-if="showSubjectError" class="text-danger font-size-13">Objet est requis.</div>
                          </b-form-group>
                        </div>

                        <b-form-group label-for="">
                          <label class="text-dark">
                            <span style="color : black">Message</span><span class="text-danger"> *</span>
                          </label>
                          <textarea
                              v-model="message"
                              class="form-control font-size-14 font-weight-normal text-dark"
                              :maxlength="3000"
                              rows="5"
                              placeholder="Ajouter votre réclamation ou suggestion"
                          />
                          <div v-if="showMessageError" class="text-danger font-size-13">Message est requis.</div>
                        </b-form-group>
                    </div>
                    <div v-if="isClaimTypeEnabled" class="col-12 col-lg-4 ml-lg-5 font-size-14 ">
                      <!-- Service  -->
                      <b-form-group   label-for="" class="pr-lg-4 ">
                        <label class="mt-3 pt-1  text-dark ">
                          <span style="color : black">Nature de l'erreur</span>
                        </label>
                        <v-select class="style-vselect-big" style="font-size:1.2em;" 
                          :options="servicesList"
                          label="name"
                          :placeholder="$t('lists.service.label')"  v-model="selectedService" :searchable="false">
                          <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                      </b-form-group>
                      <!-- Service Type  -->
                      <b-form-group v-if="selectedService && selectedService.types"  label-for="" class="col-12  pr-lg-4 ">
                          <label class=" text-dark">
                          <span style="color : black">Type de réclamation</span>
                        </label>
                          <v-select class="style-vselect-big" style="font-size:1.2em;" 
                          :options="selectedService.types"
                          :placeholder="$t('lists.type.label')" label="name" v-model="selectedType" :searchable="false">
                          <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                        </v-select>
                      </b-form-group>
                    </div>
                </div> 

                <div class="row pt-3 pb-4"> 
                    <div class="col-sm-7 col-xs-0"/>

                      <div class="col-sm-4 col-xs-12  ml-lg-5  pl-lg-4">
                        <b-button variant="primary" class="w-100 font-weight-bold text-uppercase font-size-16"  @click="addClaimWithQrc()">
                            <div v-if="isAddClaimInProgress"><b-spinner small type="border" class="mr-2"></b-spinner> Verification code QR</div>
                            <div v-else><i class="fas fa-paper-plane align-middle mr-2 ml-2 " /> Soumettre la réclamation</div>
                        </b-button>
                    </div>
                </div>

          </div>


            <div v-if="createdClaimId" class="card-body m-2 p-0">

              <div class="row">

                <div class="col-12 text-center">
                  <router-link to="/"  id="logo" >
                      <img :src="customerAsstesDiractory + 'logo.png'" alt width="150px"/>
                  </router-link>
                </div>

              </div>

              <div class="container my-4 py-4  animate__animated animate__fadeIn">



                <div class="row justify-content-center">
                  <div class="col-md-10 text-center">
                    <h2 class="text-primary font-weight-bold mb-3 font-size-18">Réclamation envoyée avec succès !</h2>
                    <p class="font-size-14 text-dark mb-4">
                        Merci pour votre message. Nous avons bien reçu votre réclamation et nous la traiterons dans les plus brefs délais.
                    </p>
                    <div class="alert alert-secondary m-4 shadow-sm" role="alert">
                      Réclamation numéro <div class="font-weight-bold text-primary font-size-14">{{ createdClaimId }}</div>
                    </div>

                    <p class="font-size-14 text-dark pt-4">
                      Vous pouvez suivre l'état de votre réclamation en vous connectant à votre compte sur notre site.
                    </p>
                    <!-- <p class="font-size-14 text-dark mb-4">
                      <router-link to="/login" class="text-primary font-weight-bold">Connectez-vous ici</router-link>
                    </p> -->

                    <b-button
                      variant="outline-primary"
                      size="lg"
                      class="px-5 py-2 mt-2 text-uppercase fw-semibold font-size-16"
                      @click="$router.push('/login')"
                    >
                      <i class="bi bi-house-door-fill me-2"></i>Connectez-vous ici
                    </b-button>
                  </div>
                </div>
              </div>

            </div>

          

        </div>

        <footer class="p-1 py-0 border-top text-primary bg-light w-100  ">
        <div class="row w-100">

          <div class="col-12 mt-2">
              <a href="/" target="_blank" class="text-decoration-none font-weight-bold font-size-12 text-primary">
                  <i class="fas fa-globe mr-1"></i>{{customerUrl}}
              </a>
            </div>
          
        
          <div class="col-8">
                <i class="fas fa-envelope font-size-12 mr-2"></i>
                <a :href="'mailto:' + customerEmail" class="text-decoration-none font-size-12 text-primary">{{ customerEmail }}</a>
          </div>

          <div class="col-4 text-right">
            <i class="fas fa-phone font-size-12  mr-2"></i>
            <a :href="'tel:' + customerPhone" class="text-decoration-none font-size-12  text-primary">{{ customerPhone }}</a>
          </div>  

            


        </div>
      </footer>

      </div>



     
    

    
                
  </div>















</template>

<style lang="scss" scoped>
footer {
  font-size: 0.9rem;
}

</style>